import React__default from 'react';
import styled, { useTheme } from 'styled-components';

const isValidCSSSize = size => /^(\d+(\.\d+)?)(px|rem|em|%|vw|vh|vmin|vmax)$/.test(size);
const getSize = (size, theme) => {
  if (size === 'small') {
    return theme.circularProgressIndicator.size.small;
  }
  if (isValidCSSSize(size)) {
    return size;
  }
  return theme.circularProgressIndicator.size.base;
};
const getStrokeWidth = ({
  strokeWidth,
  size,
  cpiTheme
}) => {
  if (typeof strokeWidth === 'number') {
    return strokeWidth;
  }
  const sizeValue = size === 'small' || size === 'base' ? cpiTheme.size[size] : size;
  if (sizeValue) {
    return parseInt(sizeValue.replace('px', ''), 10) * 0.18 / 2;
  }
  // v3 default value
  return 9;
};
const StyledSvg = /*#__PURE__*/styled.svg.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1q06c4n-0"
})(["-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;width:", ";height:", ";"], ({
  $size,
  theme
}) => getSize($size, theme), ({
  $size,
  theme
}) => getSize($size, theme));
const CircleTrail = /*#__PURE__*/styled.circle.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1q06c4n-1"
})(["fill:none;stroke:", ";"], ({
  theme,
  $color
}) => $color !== null && $color !== void 0 ? $color : theme.progressIndicator.trackColor);
const CirclePath = /*#__PURE__*/styled.circle.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1q06c4n-2"
})(["fill:none;stroke:", ";transition:stroke-dashoffset 0.35s;transform:rotate(-90deg);transform-origin:50% 50%;"], ({
  theme,
  $color
}) => $color !== null && $color !== void 0 ? $color : theme.progressIndicator.valueColor.default[100]);
const CircularProgressBar = ({
  size,
  value,
  maxValue,
  minValue,
  strokeWidth: externalStrokeWidth,
  pathColor,
  trailColor,
  strokeLinecap
}) => {
  const theme = /*#__PURE__*/useTheme();
  const cpiTheme = theme.circularProgressIndicator;
  const strokeWidth = getStrokeWidth({
    strokeWidth: externalStrokeWidth,
    size,
    cpiTheme
  });
  const sizeValue = getSize(size, theme);
  const normalizedSize = parseInt(sizeValue.replace('px', ''), 10);
  const radius = (normalizedSize - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (value - minValue) / (maxValue - minValue) * circumference;
  return /*#__PURE__*/React__default.createElement(StyledSvg, {
    $size: size,
    viewBox: `0 0 ${normalizedSize} ${normalizedSize}`,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement(CircleTrail, {
    cx: normalizedSize / 2,
    cy: normalizedSize / 2,
    r: radius,
    strokeWidth: strokeWidth,
    $color: trailColor
  }), /*#__PURE__*/React__default.createElement(CirclePath, {
    cx: normalizedSize / 2,
    cy: normalizedSize / 2,
    r: radius,
    strokeWidth: strokeWidth,
    strokeDasharray: circumference,
    strokeDashoffset: strokeDashoffset,
    strokeLinecap: strokeLinecap,
    $color: pathColor
  }));
};

export { CircularProgressBar as C, getSize as g };
//# sourceMappingURL=CircularProgressBar-D7lRW4NS.js.map
